import React, { useContext } from 'react';

import { HardwareContent, SoftwareContent } from './_Context';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { findCloudinaryImage } from '../../../utilities';
import NavBarContext from '../../../contexts/NavBarContext';
import Icon from '@components/utils/IconWrap';
import wwwApconCom from '../../../www.apcon.com';

function getProductByName(name) {
  return (
    HardwareContent.Products.find(product => product.name === name) ||
    SoftwareContent.Products.find(product => product.name === name) ||
    SoftwareContent.NameOnlyProducts.find(product => product.name === name) ||
    SoftwareContent.suite
  );
}

const organization = [
  {
    name: 'IntellaView Platform',
    color: 'gray',
  },
  {
    name: 'IntellaView Hardware',
    color: 'blue',
  },
  {
    name: 'IntellaView User Interface',
    color: 'blue',
  },
  {
    name: 'IntellaTap-VM',
    color: 'blue',
  },
  {
    name: 'ApconTap',
    color: 'gray',
  },
  {
    name: 'IntellaView Enterprise',
    color: 'blue',
  },
  {
    name: 'Enterprise Lite',
    color: 'blue',
  },
  {
    name: 'IntellaView Mobile',
    color: 'blue',
  },
];

const callsToAction = [
  {
    name: 'Request a Demo',
    href: '/schedule-demo',
    icon: 'mdi:calendar-check',
  },
  {
    name: 'Request a Quote',
    href: '/get-quote',
    icon: 'mdi:currency-usd',
  },
  {
    name: 'Legacy Products',
    href: wwwApconCom.legacyProductsPolicy,
    icon: 'ant-design:product-outlined',
  },
];

export default function ProductsDock() {
  const { navBarImages } = useContext(NavBarContext);

  return (
    <PassedInData
      items={organization}
      callToActions={callsToAction}
      images={navBarImages}
    />
  );
}

const PassedInData = ({ items, callToActions, images }) => {
  return (
    <div className="">
      <div className="mx-auto grid max-w-7xl grid-cols-4 gap-4 px-6 py-10 lg:px-8 xl:gap-x-8">
        {items.map(item => {
          const product = getProductByName(item.name);
          return (
            <div
              key={item.name}
              className="group relative rounded-lg p-6 text-sm/6 bg-base-300/50 hover:shadow-md hover:shadow-cyan-500/50"
            >
              <div className="flex items-center bg-base-300 p-2 justify-center rounded-lg h-24">
                <GatsbyImage
                  image={getImage(
                    findCloudinaryImage({
                      fileName: product.image.filename,
                      images: images,
                    })
                  )}
                  objectFit="cover"
                  className="h-full w-full  rounded-box"
                  alt={product.name}
                />
              </div>
              <a
                href={product.url}
                className="mt-3 block font-semibold text-base-content"
              >
                {product.name}
                <span className="absolute inset-0" />
              </a>
              <p className="mt-1 text-base-content line-clamp-2">
                {' '}
                {product.description}
              </p>
            </div>
          );
        })}
      </div>
      {callToActions.length > 0 && (
        <div className="bg-base-300">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="grid grid-cols-3 divide-x divide-base-100 border-x border-base-100">
              {callToActions.map(item => (
                <a
                  key={item.name}
                  href={item.href}
                  className="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-base-content hover:bg-base-200"
                >
                  <Icon
                    icon={item.icon}
                    aria-hidden="true"
                    className="size-5 flex-none text-base-content"
                  />
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
